import React from "react";
import { Select, Typography } from "antd";
import { ErrorMessage } from "@hookform/error-message";

const { Option } = Select;

const CustomSelect = (
    {
        options,
        valueKey,
        labelKey,
        renderLabel,
        label,
        icon,
        errors,
        ...restProps
    },
    ref
) => {
    return (
        <div>
            {label && <Typography.Title level={5}>{label}</Typography.Title>}
            <Select {...restProps} ref={ref}>
                {options?.map((option) => (
                    <Option key={option[valueKey]} value={option[valueKey]}>
                        {option.icon && option.icon}{" "}
                        {renderLabel ? renderLabel(option) : option[labelKey]}
                    </Option>
                ))}
            </Select>
            {errors && (
                <ErrorMessage
                    errors={errors}
                    name={restProps.name}
                    render={({ message }) => (
                        <Typography.Text type="danger">
                            * {message}
                        </Typography.Text>
                    )}
                />
            )}
        </div>
    );
};

export default React.forwardRef(CustomSelect);
